import { render, staticRenderFns } from "./gov.vue?vue&type=template&id=11bb1746&scoped=true"
import script from "./gov.vue?vue&type=script&lang=js"
export * from "./gov.vue?vue&type=script&lang=js"
import style0 from "./gov.vue?vue&type=style&index=0&id=11bb1746&prod&lang=scss"
import style1 from "./gov.vue?vue&type=style&index=1&id=11bb1746&prod&lang=scss&scoped=true"
import style2 from "./gov.vue?vue&type=style&index=2&id=11bb1746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb1746",
  null
  
)

export default component.exports